export const META_PIXEL_ID = '2290894421720846'

type Fbq = ((...args: unknown[]) => void) & {
  callMethod?: (...args: unknown[]) => void
  queue?: unknown[]
  push?: unknown
  loaded?: boolean
  version?: string
}

declare global {
  interface Window {
    fbq?: Fbq
    _fbq?: Fbq
  }
}

/**
 * Injects the official Meta Pixel base code once and fires the initial PageView.
 */
export function initMetaPixel(pixelId: string = META_PIXEL_ID): void {
  if (typeof window === 'undefined') return

  if (!window.fbq) {
    const fbq: Fbq = function (...args: unknown[]) {
      if (fbq.callMethod) {
        fbq.callMethod(...args)
      } else {
        fbq.queue?.push(args)
      }
    } as Fbq

    fbq.queue = []
    fbq.loaded = true
    fbq.version = '2.0'
    fbq.push = fbq

    window.fbq = fbq
    window._fbq = fbq

    const script = document.createElement('script')
    script.async = true
    script.src = 'https://connect.facebook.net/en_US/fbevents.js'
    document.head.appendChild(script)
  }

  window.fbq?.('init', pixelId)
  window.fbq?.('track', 'PageView')
}

/**
 * Fires a standard Meta Pixel event (e.g. "InitiateCheckout", "Purchase").
 */
export function trackPixelEvent(
  eventName: string,
  params?: Record<string, unknown>,
): void {
  if (typeof window === 'undefined') return
  window.fbq?.('track', eventName, params)
}
